import mortgageLogoSvg from './mortgageLogo.svg';

export const mortgageLogo = mortgageLogoSvg;
